export const RollingType = {
	Handicap: 1,
	UnderOver: 2,
	MatchWinnerUnderOver: 3
};

export const Status = {
	Open: 1,
	Suspended: 2,
	Closed: 3,
	Resulted: 4,
	Pending: 5,
	Removed: 6
};

export const StatusName = {
	[Status.Open]: 'Open',
	[Status.Suspended]: 'Suspended',
	[Status.Closed]: 'Closed'
};
